export default __webpack_public_path__ + "static/free-cf96534bdfd8b424c956c48be20c8a94.png";